import { render, staticRenderFns } from "./mod7.vue?vue&type=template&id=0b4dd28e&scoped=true&"
import script from "./mod7.vue?vue&type=script&lang=js&"
export * from "./mod7.vue?vue&type=script&lang=js&"
import style0 from "./mod7.vue?vue&type=style&index=0&id=0b4dd28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4dd28e",
  null
  
)

export default component.exports